<header class="topbar" [class.menu-open]="menuOpen">
  <a class="brand-link" href="#inicio" (click)="closeMenu()">
    <img src="./assets/images/netic.png" alt="NETiC" style="width:200px;">
  </a>

  <button
    type="button"
    class="menu-toggle"
    (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen"
    aria-controls="main-navigation"
    aria-label="Abrir o cerrar menú"
  >
    <span></span>
    <span></span>
    <span></span>
  </button>

  <nav id="main-navigation" class="nav-links" [class.open]="menuOpen">
    <a href="#productos" (click)="closeMenu()">Productos</a>
    <a href="#galeria" (click)="closeMenu()">Galería</a>
    <a href="#beneficios" (click)="closeMenu()">Beneficios</a>
    <a href="#funcionalidades" (click)="closeMenu()">Funcionalidades</a>
    <a href="#planes" (click)="closeMenu()">Planes</a>
    <a href="#faq" (click)="closeMenu()">Preguntas frecuentes</a>
  </nav>
  <div class="header-actions">
    <a class="btn btn-sm desktop-cta" href="https://www.netic.ar/gestion/#/authentication/signin">Ingresar</a>
  </div>
</header>

<main>
  <app-hero></app-hero>
  <app-benefits></app-benefits>
  <app-features></app-features>
  <app-how-it-works></app-how-it-works>
  <app-audience></app-audience>
  <app-pricing></app-pricing>
  <app-faq></app-faq>
  <app-final-cta></app-final-cta>
  <app-site-footer></app-site-footer>
</main>